import { render, staticRenderFns } from "./Otp.vue?vue&type=template&id=2b87dd20"
import script from "./Otp.vue?vue&type=script&lang=ts"
export * from "./Otp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../pwa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VForm,VProgressCircular})
